import styled from '@emotion/styled';


export const BadgeContainer = styled.div<{hideBadge?:boolean, earned?:boolean}>`
    height: 100%;
    width:100%;
    max-width: 200px;
    display:flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding:  ${props => props.hideBadge? "10% 0":"5% 0"};
    opacity: ${props => props.earned?"1": "0.5"};
    
    svg{
        width:100%;
        z-index: 2;
        path{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        rect{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        line{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        circle{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        polygon{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        ellipse{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
        text{
            fill:${props => props.hideBadge?"#0D5A63":""} !important;
            stroke:${props => props.hideBadge?"#0D5A63":""} !important;
        }
    }

    
`; 

export const AnimationContainer = styled.div`
    width:100%;
    z-index: 5;
`;

export const BadgeBackground = styled.div<{colors?:any, reward?:boolean}>`
    position: absolute;
    top:50%;
    left:50%;
    transform: translate(-50%, -50%) rotate(45deg);
    z-index: 1;
    width:100%;
    max-width: 190px;
    aspect-ratio: 1/1;
    border-radius: 10px;
    border:10px solid ${props => props.colors.border};
    background:${props => props.colors.background};
    display:flex;
    align-items: center;
    justify-content: center;
`; 